/* eslint-disable @typescript-eslint/no-explicit-any */
type ErrorDetail = {
  loc: string[];
  msg: string;
};

type ApiResponse = {
  detail?: ErrorDetail[];
};

export const formatErrorDetails = (
  response: ApiResponse
): Record<string, string> => {
  if (response.detail && Array.isArray(response.detail)) {
    const errors: Record<string, string> = {};
    response.detail.forEach((item) => {
      if (item.loc && Array.isArray(item.loc) && item.loc[1] && item.msg) {
        errors[item.loc[1]] = item.msg;
      }
    });
    return errors;
  }
  return {};
};

export function setFormError(error: any, setError: any) {
  if (error) {
    for (const [key, value] of Object.entries(error)) {
      setError(key as any, {
        type: "custom",
        message: value as string,
      });
    }
  }
}
